// StripeErrorの中で入力項目に関連するエラーか判定する
export const isStripeErrorInputField: (
  stripeError: stripe.StripeError,
) => boolean = (stripeError) => {
  switch (stripeError.code) {
    case 'incorrect_cvc':
    case 'incorrect_number':
    case 'invalid_cvc':
    case 'invalid_expiry_month':
    case 'invalid_expiry_year':
    case 'invalid_number':
      return true;
    default:
      return false;
  }
};
